import * as React from 'react';
import { createSvgIcon, IconDirectionality } from '..';

export const SortableArrowUp = createSvgIcon(
  { [IconDirectionality.LeftToRight]: <path fill="currentColor" d="M8 12l4-4H9V4H7v4H4z" /> },
  'small',
);
